import { createSlice } from "@reduxjs/toolkit";

const NAME = "application";

const slice = createSlice({
  name: NAME,
  initialState: {
    isOnline: navigator.onLine,
  },

  reducers: {
    navigatorIsOnline(state) {
      console.debug("Navigator is online");
      state.isOnline = true;
    },

    navigatorIsOffline(state) {
      console.debug("Navigator is offline");
      state.isOnline = false;
    },

    forceOnline(state) {
      console.debug("Forcing online");
      state.isOnline = true;
    },

    forceOffline(state) {
      console.debug("Forcing offline");
      state.isOnline = false;
    },
  },
});

/**
 * Online status setter action.
 */
export const {
  navigatorIsOnline,
  navigatorIsOffline,
  forceOnline,
  forceOffline,
} = slice.actions;

/**
 * Application slice reducer.
 */
export default slice.reducer;
